import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingContact from "@/components/FloatingContact";
import CookieBanner from "@/components/CookieBanner";
import HomePage from "@/pages/HomePage";
import TarifsParticuliers from "@/pages/TarifsParticuliers";
import TarifsProfessionnels from "@/pages/TarifsProfessionnels";
import ContactPage from "@/pages/ContactPage";
import ReservationPage from "@/pages/ReservationPage";
import PhotoboothBourgoinJallieu from "@/pages/PhotoboothBourgoinJallieu";
import NotFound from "@/pages/NotFound";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ScrollToTop from "@/components/ScrollToTop";
import { AuthProvider } from "@/context/AuthContext";

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tarifs-particuliers" element={<TarifsParticuliers />} />
          <Route path="/tarifs-professionnels" element={<TarifsProfessionnels />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/reservation" element={<ReservationPage />} />
          <Route path="/photobooth-bourgoin-jallieu" element={<PhotoboothBourgoinJallieu />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <FloatingContact />}
      {!isAdmin && <CookieBanner />}
      <Toaster position="top-right" richColors />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#0B0F19]">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <Shell />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
